<template>
  <BaseLink
    :href="isRelativeLink(link) ? undefined : linkUrl"
    :to="isRelativeLink(link) ? linkUrl : undefined"
    :target="getLinkTarget(link, isBlank)"
    theme="none"
    class="hover:opacity-80"
  >
    <div
      class="relative bg-white flex-1 xl:flex-nowrap rounded-2xl"
      :class="shadow && 'shadow-lg'"
    >
      <div
        class="absolute xl:relative t-0 l-0 w-full h-full xl:h-[80px] p-3 xl:p-4 xl:pl-3 xl:pr-2.5 flex gap-2 xl:gap-1.5 flex-col xl:flex-row items-center justify-between"
      >
        <div
          class="xl:w-[50px] xl:h-full xl:shrink-0 shrink xl:order-last w-[60%] flex-grow xl:flex-grow-0 flex items-center justify-center bg-no-repeat bg-contain bg-center"
          :style="`background-image: url(${imageUrl})`"
        />
        <div
          class="text-md w-full xl:w-auto lg:text-lg font-bold !leading-tight line-clamp-2 md:line-clamp-3 break-words text-center xl:text-left"
          :style="{
            color: textColor,
            fontWeight: fontWeight,
            fontStyle: fontStyle,
            fontSize: fontSize,
            ...useEditorFontFamily(fontFamily),
          }"
          v-html="safeTitle"
        ></div>
      </div>
      <div class="xl:hidden" style="padding-top: 100%" />
    </div>
  </BaseLink>
</template>

<script setup lang="ts">
import escape from 'lodash-es/escape'

const SHY_PLACEHOLDER = '___SHY_PLACEHOLDER___'
const SHY_TAG = '&shy;'

interface PropsInterface {
  link?: string
  isBlank?: boolean
  shadow?: boolean
  imageUrl?: string
  title?: string
  fontWeight?: string
  fontStyle?: string
  textColor?: string
  fontFamily?: string
  fontSize?: string
}

const props = defineProps<PropsInterface>()

const { getLinkTarget, getLinkUrl, isRelativeLink } = useEditorLinks()

const linkUrl = computed(() => getLinkUrl(props.link))

const safeTitle = computed(() => {
  if (!props.title) return ''

  // allow &shy;
  let sanitized = props.title.replace(SHY_TAG, SHY_PLACEHOLDER)
  sanitized = escape(sanitized)
  sanitized = sanitized.replace(SHY_PLACEHOLDER, SHY_TAG)

  return sanitized
})
</script>
